import { baseDevConfig } from "./baseEnv";

export const swmDevConfig = {
  WEB_API_NAME: "archform-dashboard-migrate",
  BACK_API_NAME: "archform-dashboard-back",
  BACK_API_NAME_V2: "archform-backend",
  BACK_API_V2_ACCESS_POLICY_API: "archform-backend-access-policy-api",
  S3_BUCKET_ARCHFORM_TEMP_FILE: "archform-temp-file-milan-dev",
  S3_BUCKET_ARCHFORM_PATIENT_DATA_V1: "archform-patient-data-v1-milan-dev",
  S3_BUCKET_ARCHFORM_PATIENT_DATA_V1_RESIZED: "archform-patient-data-v1-resized-milan-dev",
  S3_BUCKET_ARCHFORM_PATIENTS_V1: "archform-patients-v1-milan-dev",
  S3_BUCKET_ARCHFORM_PATIENT_DATA_V2: "archform-patient-data-v2",
  S3_BUCKET_ARCHFORM_PATIENTS_V2: "archform-patients-v2-milan-dev",
  S3_BUCKET_ARCHFORM_WEBVIEWER_DATA_V2: "archform-webviewer-data-v2-milan-dev",
  S3_BUCKET_ARCHFORM_AUTO_RETAINER_DATA: "archform-autoretainer-data-test",
  AWS_REGION: "eu-south-1",
  AMPLIFY_USER_POOL_ID: "eu-south-1_eO1PMYEgB",
  AMPLIFY_IDENTITY_POOL_ID: "eu-south-1:d06fb486-28b6-4897-880d-9890320b9268",
  AMPLIFY_USER_POOL_WEB_CLIENT_ID: "7degdk30l3hb3mbb8vpq23hf78",
  
  WEB_API_ENDPOINT: "https://ihmoewfq5a.execute-api.eu-south-1.amazonaws.com/Prod/",
  BACK_API_ENDPOINT: "https://ihmoewfq5a.execute-api.eu-south-1.amazonaws.com/Prod",
  BACK_API_ENDPOINT_V2: "https://p1puv13xpc.execute-api.eu-south-1.amazonaws.com/Prod",
}
